import React from "react"
import PropTypes from "prop-types"
import LabelInput from "../labels-input/index.jsx"
import styles from "../labels-input/styles.less"
import autosuggestStyles from "../autosuggest-input/autosuggest-input.less"
import $ from "jquery"
import appStorage from "@cirrus/legacy/app-components/app-settings/index.es6"
import ClassNames from "classnames"
import createReactClass from "create-react-class"

var EditableLabelInput = createReactClass({
  propTypes: {
    value: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    className: PropTypes.string,
    loadPromise: PropTypes.func.isRequired,
    getSuggestionValue: PropTypes.func.isRequired,
    getSuggestionId: PropTypes.func.isRequired,
    filterList: PropTypes.func,
  },
  getInitialState: function () {
    return {
      isOpen: false,
    }
  },
  componentWillMount() {
    window.addEventListener("click", this.changeOpenState)
  },
  componentWillUnmount() {
    window.removeEventListener("click", this.changeOpenState)
  },
  changeOpenState(e) {
    var isOpen =
      !!$(e.target)
        .closest("." + styles.editableContainer)
        .size() ||
      !!$(e.target)
        .closest("." + autosuggestStyles.sectionContainer)
        .size()

    if (this.state.isOpen == isOpen) {
      return
    }

    this.setState({ isOpen: isOpen }, () => {
      if (isOpen) {
        $("." + styles.container)
          .find("input")
          .focus()
      }
    })
  },
  render() {
    return (
      <div className={styles.editableContainer}>
        <LabelInput
          className={ClassNames(this.props.className, {
            [styles.hidden]: !this.state.isOpen,
          })}
          isOpen={this.state.isOpen}
          value={this.props.value}
          loadPromise={this.props.loadPromise}
          onChange={this.props.onChange}
          onDelete={this.props.onDelete}
          getSuggestionValue={this.props.getSuggestionValue}
          getSuggestionId={this.props.getSuggestionId}
          filterList={this.props.filterList}
        />
        <div className={ClassNames({ [styles.hidden]: this.state.isOpen })}>
          {this.props.value.length ? (
            <div className={styles.editableRepresentation}>
              <ul className={styles.list}>
                {this.props.value.map((item, i) => (
                  <li key={item.id} className={styles.item}>
                    <div className={styles.value}>
                      <span>{this.props.getSuggestionValue(item)}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className={styles.editableEmpty}>
              {appStorage.translationFunction("General:Empty")}
            </div>
          )}
        </div>
      </div>
    )
  },
})

export default EditableLabelInput
